import { deleteBanner, getBannersPanel} from "../../services/BannersService";
import { BannersContext } from "./BannersContext"

export const BannersState = ({ children }) => {
    const getBannersPanelData = async (searchTerm,numPagina, filas) => {
        let res = await getBannersPanel(searchTerm,numPagina, filas);
        return res;
    }
 
    const deleteBannerData = async (body,searchTerm,numPagina, filas) => {
        const res = await deleteBanner(body)
        if (res) getBannersPanelData(searchTerm,numPagina, filas)
        return res
    }

    return <BannersContext.Provider value={{
        deleteBannerData,
        getBannersPanelData,
    }} >
        {children}
    </BannersContext.Provider>
}